/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type
 */
export enum CommercialType {
    TV = 'TV',
    Radio = 'Radio',
    Digital = 'Digital',
    Print = 'Print',
    OOH = 'OOH',
    Social = 'Social',
    BTS = 'BTS',
    Other = 'Other',
}
